import { SAVE_FILTERS } from "../utils/actionTypes";

const INITIAL_STATE = {
  filters: [],
};

const saveFilters = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SAVE_FILTERS:
      return {
        ...state,
        filters: action.payload.filters,
      };
    default:
      return state;
  }
};

export default saveFilters;



// WEBPACK FOOTER //
// ./src/reducers/saveFilters.js